import { Controller } from "@hotwired/stimulus"
import { Modal } from "../utils/modal"

export default class extends Controller {
  static values = { maxLength: String }

  connect() {
    this.element.addEventListener("submit", (event) => this.validateMessageBodyLimit(event));
  }

  validateMessageBodyLimit(event) {
    const wordCount = tinymce.activeEditor.plugins.wordcount;
    const characterCount = wordCount.body.getCharacterCount();

    if (characterCount > parseInt(this.maxLengthValue, 0)) {
      event.preventDefault();
      Modal.danger({
        title: window.I18n.modal.danger.title,
        message: window.I18n.notifications.max_chars_message,
        confirmText: window.I18n.general.okay,
      });
    }
  }
}
